import type { RichTextValue } from '@vedalib/rich-text'
import React, { useCallback } from 'react'

import type { IAppTextProps } from 'components/AppText'
import RichText from 'components/AppText'
import type { AdapterKitControlProps } from 'components/formKit/types'

const FieldRichText = ({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IAppTextProps, RichTextValue>) => {
  const handleChange = useCallback(
    (value: RichTextValue) => onChange({ name, value }),
    [name, onChange],
  )

  return <RichText {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldRichText) as typeof FieldRichText
